import {Brick, registerBrick} from 'olympe';

/**
 * Add a binding in a bindings object
 */
export default class OGAddBinding extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} bindings
     * @param {string} field
     * @param {string} value
     * @param {function()} forwardEvent
     * @param {function(*)} setBindings
     */
    update($, [bindings, field, value], [forwardEvent, setBindings]) {
        if (!bindings || !('bindings' in bindings)) {
            return;
        }

        const newBindings = {...bindings};
        newBindings.bindings[field] = value;

        setBindings(bindings);
        forwardEvent();
    }
}

registerBrick('0198f0a7751b5e62a49c', OGAddBinding);
